module.exports = __webpack_public_path__ + "static/img/xsggtffy.b373b2f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ym/xsggtffy.png
// module id = enau
// module chunks = 1